const CONFIG = {
  URL: "https://wcuagm-api.eventqiu.com/api",
  TOKEN_VOTING: "eyJpZF9hZG1pbiI6IjEiLCJ0b2tlbiI6IllYdFFBYklpRld4ZldGcWhCa2x4MSIsInJvbGUiOiJzdXBlcl9hZG1pbiJ9.8HQOJjKz7r0FdGmHxljOGPEzjCEqb9wpYH2Kiu9ElaY"
};

export default CONFIG;
